<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="col-md text-center mt-1 mb-1 m-0 p-0">
  <!-- <span *ngIf="isMobileActive == true" (click)="snav.close()" class="cross"
    >x</span
  > -->
  <img
    class="side_logo"
    src="../../../../assets/images/image(2).png"
    alt=""
    (click)="navigate()"
  />
  <hr class="img_line" />
</div>
<mat-nav-list appAccordion>
  <div>
    <mat-list-item
      appAccordionLink
      *ngFor="let menuitem of menuList; index as i"
      group="{{ menuitem.state }}"
    >
      <a
        (click)="activeRoute(i)"
        [ngClass]="{ selected: readLocalStorageValue('activeIndex') == i }"
        appAccordionToggle
        [routerLink]="[menuitem.state]"
        *ngIf="menuitem.type !== 'nolink'"
      >
        <span *ngIf="readLocalStorageValue('activeIndex') !== i"
          ><img class="logo_icon" [src]="menuitem.iconUrl"
        /></span>
        <span *ngIf="readLocalStorageValue('activeIndex') == i"
          ><img class="logo_icon" [src]="menuitem.iconUrlActive"
        /></span>
        <span class="menu_label">{{ menuitem.name }}</span>
        <span fxFlex></span>
        <span
          class="label label-{{ badge.type }}"
          *ngFor="let badge of menuitem.badge"
          >{{ badge.value }}</span
        >
      </a>
    </mat-list-item>
  </div>

  <!-- <ul class="_side_bottom_menu d-inline-block" *ngIf="(this.userData['4'] == true && this.userData['5'] == true) || podcastVal['data'] == true || this.userData['5'] == true">
        <li class="mb-3">
         <ui-switch size="small" color="#3d5362" [(ngModel)]="isAllow"  (ngModelChange)="switchUser($event)"></ui-switch><p class="side_bottom_inner">Allow creative to reach out</p>
        </li>
    </ul> -->
  <div></div>
</mat-nav-list>
